<div class="synergy-card" *ngIf="partner">

  <mat-card class="item-card">
    <mat-card-content>

      <!--begin::Content-->
      <div class="wallet_coop_wrapper s_archive_wrapper">
        <div class="coop s_archive row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12 s_archive-img-container">
                <div class="s_archive-img partner-img">
                  <img src={{avatar}} alt={{partner.name}} />
                  <!-- <img src={{partner.imageURL}} alt={{partner.name}} /> -->
                  <div class="s_archive-category">{{partner.sector | sector_filter}}</div>
                  <!-- <div class="s_archive-category">{{partner.sector | sector_filter: (sectorList$ | async)}}</div> -->
                </div>
              </div>
            </div>
            <div class="s_archive-content container-fluid">
              <div class="s_archive-heading row">
                <h4 class="s_archive-title col-md-12">{{partner.name}}</h4>
              </div>
              <div class="s_archive-subtitle row">
                <div class="col-md-12">
                  <p [innerHTML]="partner.subtitle"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 s_archive-info">
                  <div class="s_archive-partner">
                    <div class="s_archive-merch-address" *ngIf="partner.address">
                      <span class="mdi mdi-pin"></span> {{partner.address.street}} , {{partner.address.city}}
                    </div>
                    <div class="s_archive-merch-phone" *ngIf="partner.phone">
                      <a href="tel:+{{partner.phone}}"><span class="mdi mdi-phone"></span>
                        {{partner.phone}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content-->

    </mat-card-content>
  </mat-card>
</div>
